
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/font-generator",
      function () {
        return require("private-next-pages/font-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/font-generator"])
      });
    }
  